import API from "./API";

export const getAllSellerOrdersApi = async (payload) => {
  try {
    const response = await API.get(
      `/orders/seller/list?page=${payload?.page || 0}&size=${payload?.size || 10
      }&search=${payload?.search || ""}&sortBy=${payload?.sortby || ""
      }&sortDir=${payload?.sortdir || ""}&orderStatus=${payload?.orderStatus || ""
      }`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateOrderStatusApi = async (payload) => {
  try {
    const response = await API.put(
      `/orders/${payload?.orderItemId || 0}/status`,
      payload
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllOrdersApi = async (payload) => {
  try {
    const response = await API.get(
      `/orders?page=${payload?.page || 0}&size=${payload?.size || 10}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const shipOrderApi = async (payload) => {
  try {
    const response = await API.post(
      `/ship/now?orderItemId=${payload?.orderItemId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const printManifestOrderApi = async (payload) => {
  try {
    const response = await API.post(
      `/manifests/generate?orderItemId=${payload?.orderItemId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const printInvoiceOrderApi = async (payload) => {
  try {
    const response = await API.post(
      `/invoice/generate?orderItemId=${payload?.orderItemId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const printLabelOrderApi = async (payload) => {
  try {
    const response = await API.post(
      `/label/generate?orderItemId=${payload?.orderItemId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const magicImageUrlApi = async (payload) => {
  try {
    const response = await API.get(`v1/magic/image/presigned-url?fileName=${payload?.fileName || ''}&contentType=${payload?.contentType || ''}&orderItemId=${payload?.orderItemId || ''}&fileType=${payload?.fileType || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getMagicImageUrlApi = async (payload) => {
  try {
    const response = await API.get(`/single/video-image-map?orderItemId=${payload?.orderItemId || ''}&mapUploadID=${payload?.mapUploadID || ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const videosMaPApi = async (payload) => {
  try {
    const response = await API.post(
      `/${payload?.orderItemId}/videos/map?videouploadId=${payload?.videouploadId || 0}&imageUploadId=${payload?.imageUploadId}&mapUploadID=${payload?.mapUploadID}&orderItemId=${payload?.orderItemId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
